import { render, staticRenderFns } from "./ElectricityIndexSelect.vue?vue&type=template&id=70ce1ace"
import script from "./ElectricityIndexSelect.vue?vue&type=script&lang=js"
export * from "./ElectricityIndexSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports